<template>
  <div class="bank-card-add">
    <van-form
        ref="form"
        label-align="center"
        @submit="save">
      <div class="bg-10px"></div>
      <van-field
          v-model="cardholder"
          clearable
          label="持卡人姓名"
          placeholder="请输入持卡人姓名"
          :rules="[{required: true, message: '必填'}]"
      >
      </van-field>
      <div class="bg-10px"></div>
      <van-field
          v-model="bankNumber"
          clearable
          type="number"
          minLength="6"
          maxLength="20"
          label="银行卡号"
          placeholder="请输入银行卡号"
          :rules="[{required: true, message: '必填'}, { pattern: /^[1-9]\d{6,20}$/, message: '请输入正确的银行卡号' }]"
      >
      </van-field>
      <div class="bg-10px"></div>
      <van-field
          v-model="bankName"
          clearable
          label="银行名称"
          placeholder="请输入银行名称"
          :rules="[{required: true, message: '必填'}]"
      >
      </van-field>
      <div class="btn-con" style="padding: 20px;">
        <van-button round block type="info" native-type="submit">保存</van-button>
      </div>
    </van-form>

  </div>
</template>

<script>
import { bankBind } from '@/api/wallet/cash'
export default {
  components: {
  },
  data(){
    return{
      cardholder: '', // 姓名
      bankNumber: '', // 银行卡号
      bankName: '', // 银行名称
    }
  },
  created(){

  },
  methods: {

    //获取银行卡列表
    save(){
      this.$refs['form'].validate().then(()=>{
        let req = {
          cardholder: this.cardholder,
          bankNumber: this.bankNumber,
          bankName: this.bankName,
          openid: this.session('userOpenId')
        }
        bankBind(req).then(res=>{
          if(res.code===200){
            this.$router.go(-1)
          }
        })
      })
    },
  }
}
</script>

<style lang="less" scoped>
.bank-card-add{

  .btn-con{
    padding: 40px 15px 0;
  }
}
</style>